export default __webpack_public_path__ + "static/media/sampleMetroCard_Front.5241fafe.png";